module.exports = __webpack_public_path__ + "static/media/Google_logo.19ea21a9.svg";